import { render } from "./CreateGalleryItemModal.vue?vue&type=template&id=05d30902&scoped=true"
import script from "./CreateGalleryItemModal.vue?vue&type=script&lang=js"
export * from "./CreateGalleryItemModal.vue?vue&type=script&lang=js"

import "./CreateGalleryItemModal.vue?vue&type=style&index=0&id=05d30902&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d30902"]])

export default __exports__